import axios from "axios";

const getTimelineFromApi = (uuid, signal) =>
  axios.get(`/api/v4/transactions/timeline/${uuid}`, {
    authenticity_token: window.ReactOnRails.authenticityToken(),
    signal,
  });

export default getTimelineFromApi;
